import { strIsNullOrEmpty, tryParseJSONObject } from '@fox/atoms/utils/string';
import { AddressType } from '../../location-map-block/contracts';
import { QuestionValidator } from '../util/allow-next';
export const addressRequirementsValidator: QuestionValidator = answer => {
	if (!answer) return false;
	const required: (keyof Omit<typeof parsedAnswer, 'lat' | 'lng' | 'postcode_only'>)[] = ['address1', 'country', 'locality', 'postcode', 'state'];
	const parsedAnswer = tryParseJSONObject<Omit<AddressType, 'rawAddressInput' | 'imageUrl' | 'mapStyle' | 'addressTypeId'> & { postcode_only?: boolean }>(
		answer?.answer?.answerJson,
		{}
	);

	if (parsedAnswer.postcode_only) {
		return !strIsNullOrEmpty(parsedAnswer.formatted) && parsedAnswer.formatted?.length >= 4;
	} else {
		return required.every(field => !strIsNullOrEmpty(parsedAnswer[field]?.trim()));
	}
};
